export default __webpack_public_path__ + "static/media/logo_collapsed.1ed5ac0c.svg";